export default function Minus({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 11H18V13H6V11Z" fill="currentColor" />
    </svg>
  )
}
